export interface DownloadedFile {
  blob: Blob;
  filename: string;
}

export function resolveAttachmentFilename(
  contentDisposition: string | undefined,
  fallbackFilename: string
): string {
  if (contentDisposition === undefined) {
    return fallbackFilename;
  }
  const match = /filename="?([^"]+)"?/.exec(contentDisposition);
  if (match === null) {
    return fallbackFilename;
  }
  const extractedFilename = match[1];
  return extractedFilename === undefined ? fallbackFilename : extractedFilename;
}

export function saveDownloadedFile(downloaded: DownloadedFile): void {
  const objectUrl = URL.createObjectURL(downloaded.blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = downloaded.filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}
